import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Khassida } from '../../types';

export type State = Khassida[];

const initialState: State = [];

export const KhassidaSlice = createSlice({
  name: 'khassida',
  initialState,
  reducers: {
    onSetKhassida: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeleteKhassida: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetKhassida, onDeleteKhassida } = KhassidaSlice.actions;

export default KhassidaSlice.reducer;
